import { user } from 'shared/api/query/configs.json';

export const identity = () => {
  const func = {
    model: user.model,
    func: { name: 'uid', args: [{ isGraphQLVar: true, value: '$identity' }] },
  };
  return func;
};
